import { ofType } from 'redux-observable'
import { empty } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'
import * as Actions from 'store/actions/index.ts'
import { getSaleTitle } from 'store/selectors'

const isSaleFetched = (action) => // (action: ResourceFetchedAction)
  action.payload.type === 'sale'

const pageTitleEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.resources.RESOURCE_FETCHED),
  filter(isSaleFetched),
  switchMap(() => {
    const state = state$.value
    const saleTitle = getSaleTitle(state)
    const [titleTag] = document.getElementsByTagName('title')

    if (titleTag) {
      titleTag.innerText = saleTitle
    }

    return empty()
  })
)

export default pageTitleEpic
